export const INVOICE_TYPES = [
  { label: "Debit Invoice", value: "invoice" },
  { label: "Credit Note", value: "credit_note" }
];
